/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style7 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _style8 = require('antd/lib/icon/style');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _style9 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _style10 = require('antd/lib/col/style');

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _style11 = require('antd/lib/row/style');

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style12 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

require('./index.less');

var _tool = require('util/tool');

var _config = require('util/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var uuid = 0;

var DynamicFieldSet = function (_Component) {
  (0, _inherits3.default)(DynamicFieldSet, _Component);

  function DynamicFieldSet(props, context) {
    (0, _classCallCheck3.default)(this, DynamicFieldSet);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DynamicFieldSet.__proto__ || (0, _getPrototypeOf2.default)(DynamicFieldSet)).call(this, props, context));

    _this.remove = function (k) {
      var form = _this.props.form;
      // can use data-binding to get

      var keys = form.getFieldValue('keys');
      // We need at least one passenger

      // can use data-binding to set
      form.setFieldsValue({
        keys: keys.filter(function (key) {
          return key !== k;
        })
      });
    };

    _this.add = function () {
      uuid++;
      var form = _this.props.form;
      // can use data-binding to get

      var keys = form.getFieldValue('keys');

      var nextKeys = keys.concat(uuid);
      // can use data-binding to set
      // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys
      });
    };

    _this.getData = function (obj) {
      var arr = [];
      var params = _this.props.params;

      for (var i = 0; i <= uuid; i++) {

        var o = {
          //registerNumber: obj[`device-name-${i}`],
          productId: params.id,
          registerNumber: _this.state.registerNumber,
          serialNumber: obj['device-no-' + i]
          // debugger
        };arr.push(o);
      }

      return arr;
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();
      _this.props.form.validateFields(function (err, values) {

        if (!err) {
          //向父级传递数据
          var tmp = _this.getData(values);

          _this.props.addDevice(tmp, function () {
            _this.resetForm();
          });
          // console.log('Received values of form: ', values);

          // this.addDevice(values);
        }
      });
    };

    _this.resetForm = function () {
      uuid = 0;
      _this.props.form.resetFields();
    };

    _this.state = {
      "registerNumber": ""
    };
    return _this;
  }

  (0, _createClass3.default)(DynamicFieldSet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var params = this.props.params;

      var options = {
        productId: params.id
        //console.log(params)
      };(0, _tool.http)(_config.apiJson.getProduct, options).then(function (res) {
        //console.log(res)
        _this2.setState({
          registerNumber: res.registerNumber
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          form = _props.form,
          onOk = _props.onOk,
          onCancel = _props.onCancel;
      var getFieldDecorator = form.getFieldDecorator,
          getFieldValue = form.getFieldValue;
      // addDevice('qqq')

      var formItemLayout = {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      };
      var formItemLayoutWithOutLabel = {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      };

      getFieldDecorator('keys', { initialValue: [] });

      var keys = getFieldValue('keys');

      var formItems = keys.map(function (k, index) {
        return (0, _jsx3.default)(_row2.default, {
          gutter: 8
        }, k, (0, _jsx3.default)(_col2.default, {
          span: 21
        }, void 0, _react2.default.createElement(
          FormItem,
          (0, _extends3.default)({}, formItemLayout, {
            label: '\u6869\u53F7',
            required: false,
            key: k }),
          getFieldDecorator('device-no-' + k, {
            validateTrigger: ['onChange', 'onBlur'],
            rules: [{
              required: true,
              whitespace: true,
              message: "请输入桩号"
            }]
          })((0, _jsx3.default)(_input2.default, {
            placeholder: '\u6869\u53F7',
            style: { 'width': '80%', 'marginRight': '8px' }
          })),
          (0, _jsx3.default)(_icon2.default, {
            className: 'dynamic-delete-button',
            type: 'minus-square-o',
            disabled: keys.length === 1,
            onClick: function onClick() {
              return _this3.remove(k);
            }
          })
        )));
      });

      return (0, _jsx3.default)(_form2.default, {}, void 0, formItems, (0, _jsx3.default)(_row2.default, {
        gutter: 8
      }, 0, (0, _jsx3.default)(_col2.default, {
        span: 21
      }, void 0, _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({}, formItemLayout, {
          label: '\u6869\u53F7',
          required: false,
          key: 0 }),
        getFieldDecorator('device-no-' + 0, {
          validateTrigger: ['onChange', 'onBlur'],
          rules: [{
            required: true,
            whitespace: true,
            message: "请输入桩号"
          }]
        })((0, _jsx3.default)(_input2.default, {
          placeholder: '\u6869\u53F7',
          style: { 'width': '80%', 'marginRight': '8px' }
        }))
      ))), (0, _jsx3.default)(_row2.default, {
        className: 'form-modal-footer'
      }, void 0, _react2.default.createElement(
        FormItem,
        formItemLayoutWithOutLabel,
        (0, _jsx3.default)(_button2.default, {
          onClick: onCancel
        }, void 0, '\u53D6\u6D88'),
        (0, _jsx3.default)(_button2.default, {
          type: 'primary',
          onClick: this.handleSubmit
        }, void 0, '\u786E\u8BA4')
      )));
    }
  }]);
  return DynamicFieldSet;
}(_react.Component);

;

var WrappedDynamicFieldSet = _form2.default.create()(DynamicFieldSet);

exports.default = (0, _reactRouter.withRouter)(WrappedDynamicFieldSet);

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/device/home/device-form/index.jsx
// module id = 818
// module chunks = 0